export default __webpack_public_path__ + "static/media/AAM 840_300 (1).3a916918.png";